import { render, staticRenderFns } from "./ItemCategoryQueryResult.vue?vue&type=template&id=0a207323&"
import script from "./ItemCategoryQueryResult.vue?vue&type=script&lang=js&"
export * from "./ItemCategoryQueryResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports